import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BusinessUnitDto } from '../../models/business-unit.dto';

@Injectable({
  providedIn: 'root'
})
export class BusinessUnitService {

  private readonly path = '/businessUnit';
    
    constructor(private http: HttpClient) {}
    
    getAll(): Observable<BusinessUnitDto[]> {
      return this.http.get<BusinessUnitDto[]>(`${environment.apiBaseUrl}${this.path}`);
    }
}
